import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import styled, { keyframes } from "styled-components";
import pephubLogo from "../Images/pephub-board.svg";

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%,
  100% {
    transform: scale(1);
    opacity: 0.82;
  }
  50% {
    transform: scale(1.06);
    opacity: 1;
  }
`;

const blink = keyframes`
  0%,
  80%,
  100% {
    opacity: 0.18;
  }
  40% {
    opacity: 1;
  }
`;

const Shell = styled.div`
  width: 170px;
  display: grid;
  justify-items: center;
  gap: 0.8rem;
`;

const Orbital = styled.div`
  position: relative;
  width: 92px;
  height: 92px;
  border-radius: 999px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  display: grid;
  place-items: center;
`;

const Ring = styled.div`
  position: absolute;
  inset: -2px;
  border-radius: 999px;
  border-top: 2px solid var(--brand-blue);
  border-right: 2px solid transparent;
  border-bottom: 2px solid transparent;
  border-left: 2px solid transparent;
  animation: ${spin} 1.2s linear infinite;
`;

const RingInner = styled(Ring)`
  inset: 10px;
  border-top-color: var(--sky-tint);
  animation-duration: 1.9s;
  animation-direction: reverse;
`;

const Core = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.94);
  display: grid;
  place-items: center;
  box-shadow: 0 8px 16px rgba(7, 22, 58, 0.24);
  animation: ${pulse} 1.3s ease-in-out infinite;
`;

const Brand = styled.img`
  width: 28px;
  height: auto;
  display: block;
`;

const Label = styled.p`
  margin: 0;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.94);
`;

const DotRow = styled.div`
  display: inline-flex;
  gap: 0.24rem;
`;

const Dot = styled.span`
  width: 0.34rem;
  height: 0.34rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);
  animation: ${blink} 1.15s ease-in-out infinite;
  animation-delay: ${(props) => props.delay};
`;

export default function LoadingScreen() {
  return (
    <Backdrop
      sx={{
        color: "var(--surface-white)",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: "rgba(26, 35, 64, 0.54)",
      }}
      open={true}
    >
      <Shell>
        <Orbital>
          <Ring />
          <RingInner />
          <Core>
            <Brand src={pephubLogo} alt="PepHub Boards" />
          </Core>
        </Orbital>
        <Label>Loading workspace</Label>
        <DotRow>
          <Dot delay="0s" />
          <Dot delay="0.16s" />
          <Dot delay="0.32s" />
        </DotRow>
      </Shell>
    </Backdrop>
  );
}
